module.exports = __webpack_public_path__ + "img/bar-chart-stacked-light-02.4202d2c8.jpg";